/**
 * Which CrowdSec collections a server has, and which it could use (P11.9.2).
 *
 * `INSTALLER_COLLECTIONS` mirrors what `installer/lib/crowdsec.sh` installs by
 * what runs on the server (P5.1): those are the installer's, never removed by
 * Bartizo, and shown as such. `RECOMMENDED_COLLECTIONS` are hub collections worth
 * adding by role — each checked to exist in the hub (1.8.1's index, 2026-10-07)
 * and to work on logs CrowdSec already reads on such a server, or saying what more
 * it needs. Recommendations are advice for a person; nothing installs them by itself.
 */
export const INSTALLER_COLLECTIONS = [
    'crowdsecurity/linux',
    'crowdsecurity/sshd',
    'crowdsecurity/nginx',
    'crowdsecurity/apache2',
    'crowdsecurity/mysql',
    'crowdsecurity/mariadb',
    'crowdsecurity/pgsql',
];
export const RECOMMENDED_COLLECTIONS = [
    {
        name: 'crowdsecurity/http-cve',
        title: 'Known web exploits',
        why: 'Requests trying published vulnerabilities — Log4Shell, Spring4Shell, router and CMS CVEs — seen in the web server’s log.',
        roles: ['web'],
    },
    {
        name: 'crowdsecurity/wordpress',
        title: 'WordPress',
        why: 'Login guessing, user enumeration and probing for wp-config backups.',
        roles: ['web'],
        when: 'A site on this server runs WordPress.',
    },
    {
        name: 'crowdsecurity/whitelist-good-actors',
        title: 'Good actors',
        why: 'Keeps known search engines and CDNs from being banned by a scenario that mistakes them for scanners.',
        roles: ['web'],
    },
    {
        name: 'crowdsecurity/nextcloud',
        title: 'Nextcloud',
        why: 'Login guessing against Nextcloud.',
        roles: ['web'],
        when: 'The server runs Nextcloud.',
        needs: 'Nextcloud’s own log added to CrowdSec’s acquisition (labels type: Nextcloud).',
    },
    {
        name: 'crowdsecurity/linux-lpe',
        title: 'Privilege escalation',
        why: 'Exploits of pkexec (CVE-2021-4034) and glibc’s loader (CVE-2023-4911) seen in the system log.',
        roles: ['base'],
    },
    {
        name: 'crowdsecurity/auditd',
        title: 'auditd',
        why: 'Suspicious commands from the kernel’s audit log, such as a web server user starting a shell.',
        roles: ['base'],
        needs: 'auditd installed, and /var/log/audit/audit.log added to CrowdSec’s acquisition.',
    },
];
/** What suits a server with these roles, in the catalog's order. */
export const recommendedFor = (roles) => RECOMMENDED_COLLECTIONS.filter((entry) => entry.roles.some((role) => role === 'base' || roles.includes(role)));
//# sourceMappingURL=crowdsec-catalog.js.map